import styled from "styled-components";

export const Container = styled.div``;

export const Main = styled.div`
	padding: 42px 30px;
`;